import { render, staticRenderFns } from "./MenuOptionSelector.vue?vue&type=template&id=568c34fd&scoped=true&"
import script from "./MenuOptionSelector.vue?vue&type=script&lang=ts&"
export * from "./MenuOptionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MenuOptionSelector.vue?vue&type=style&index=0&id=568c34fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c34fd",
  null
  
)

export default component.exports